"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactColor = require("react-color");
var _icon = _interopRequireDefault(require("../icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ColorPicker = /*#__PURE__*/function (_Component) {
  _inherits(ColorPicker, _Component);
  var _super = _createSuper(ColorPicker);
  function ColorPicker() {
    var _this;
    _classCallCheck(this, ColorPicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "stopPropagation", function (event) {
      event.stopPropagation();
    });
    _defineProperty(_assertThisInitialized(_this), "onChange", function (color) {
      var onChange = _this.props.onChange;
      onChange('color', color.hex);
    });
    _defineProperty(_assertThisInitialized(_this), "renderModal", function () {
      var color = _this.props.currentState.color;
      return /*#__PURE__*/_react["default"].createElement("div", {
        onClick: _this.stopPropagation,
        className: "rdw-color-picker-modal",
        role: "button",
        tabIndex: -1,
        onKeyDown: function onKeyDown() {
          return null;
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactColor.BlockPicker, {
        color: color,
        onChangeComplete: _this.onChange
      }));
    });
    return _this;
  }
  _createClass(ColorPicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        expanded = _this$props.expanded,
        onExpandEvent = _this$props.onExpandEvent;
      return /*#__PURE__*/_react["default"].createElement("div", {
        "aria-haspopup": "true",
        "aria-expanded": expanded,
        "aria-label": "rdw-color-picker",
        className: "rdw-color-picker"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        onClick: onExpandEvent,
        className: "rdw-dropdown-wrapper",
        role: "button",
        tabIndex: 0,
        onKeyDown: function onKeyDown() {
          return null;
        }
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        icon: "ion-android-color-palette",
        size: 24,
        className: "rdw-dropdown-selectedtext"
      })), expanded ? this.renderModal() : undefined);
    }
  }]);
  return ColorPicker;
}(_react.Component);
ColorPicker.defaultProps = {
  expanded: false,
  onExpandEvent: function onExpandEvent() {
    return null;
  },
  onChange: function onChange() {
    return null;
  },
  currentState: {
    color: null
  }
};
ColorPicker.propTypes = {
  expanded: _propTypes["default"].bool,
  onExpandEvent: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  currentState: _propTypes["default"].shape({
    color: _propTypes["default"].shape({})
  })
};
ColorPicker.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "stopPropagation",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "color",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderModal",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "ColorPicker",
  "props": {
    "expanded": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onExpandEvent": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "currentState": {
      "defaultValue": {
        "value": "{\r\n  color: null,\r\n}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "color": {
            "name": "shape",
            "value": {},
            "required": false
          }
        }
      },
      "required": false
    }
  }
};
var _default = ColorPicker;
exports["default"] = _default;